<template>
  <div class="aw-enterprise">
    <div class="com-desc-box">
      <div class="container-center new-box">
        <div class="nw-part" style="float:left">
            <ul class="new-list" >
                <li
                    v-for="(item, index) in newList"
                    :key="index"
                    @click="goDetail(item)"
                >
                    <div class="new-left">
                        <span class="day">{{ extractYearMonthDay(item.updateTime).day }}</span>
                        <div class="com-month">
                            /
                            <span class="month"
                            >{{ extractYearMonthDay(item.updateTime).month }}月</span
                            >
                            <div class="year">
                            {{ extractYearMonthDay(item.updateTime).year }}
                            </div>
                        </div>
                    </div>
                    <div class="new-right">
                        <span class="news-title">{{ item.title }}</span>
                        <!-- <div class="news-desc">{{ truncateString(item.summary) }}</div> -->
                        <div class="news-desc">{{ item.summary }}</div>
                    </div>
                </li>
            </ul>
            <el-pagination layout="prev, pager, next"  :current-page.sync="currentPage" :pager-count="5" :total="total" :prev-text="'上一页'" :next-text="'下一页'" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <div class="active-list" v-if="actives.length > 0">
          <div class="act-title">
            <span></span>
            最新活动
          </div>
          <ul>
            <li v-for="(item, index) in actives" :key="index" @click="queryAct(item)">
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {queryNewsList, queryActiveList} from '@/api/common.js'

export default {
  data() {
    return {
      newList: [
        {
          updateTime: "2024-11-01",
          title: "海云捷迅农业智联网沙盘 加速农业智能化步伐",
          summary: "在现代农业的发展中，科技的力量不容小觑。海云捷迅集成了物联网、人工智能和FPGA技术等产品，推出农业智联网沙盘，旨在为农作物温室培养提供全面的智能化解决方案案案案案案案案案案案案案案案。",
          article:
            "在现代农业的发展中，科技的力量不容小觑。海云捷迅集成了物联网、人工智能和FPGA技术等产品，推出农业智联网沙盘，旨在为农作物温室培养提供全面的智能化解决方案。<br/><br/>通过该解决方案，用户可以在平台端和移动APP端通过可视化数据展示和远程控制技术，让用户及时了解力棚内环境的变化趋势、农作物健康状况和大棚安全情况，并根据实际需要对大棚进行通风、灌溉、遮光、照明、加温等功能的自动化控制，实现对农业大棚智慧、高效、科学化管理。<br/><br/>核心优势<br/><br/>环境数据采集与监测：通过高精度传感器，实时监测大棚内的温度、湿度、土壤参数等关键环境指标，确保农作物生长在最佳条件下。<br/><br/>远程控制与管理：<br/><br/>通过移动APP端，用户可以远程控制大棚内的通风、灌溉、遮光、照明和加温等设备，实现自动化管理。<br/><br/>可视化数据展示：<br/><br/>监控大屏实时显示当前空气温湿度、土壤温湿度、大气压强、土壤PH值、土壤电导率、土壤含盐量、光照强度、二氧化碳含量等环境参数，并将历史环境数据生成数据曲线图便于决策分析。<br/><br/>病害检测：<br/><br/>使用农作物病害样本集，基于YOLOv3算法模型训练得到农作物病害识别智能算法模型，利用VPU芯片进行农作物病害实时检测并在大屏中展示检测结果，显示病因并提出防治方法。<br/><br/>入侵检测：<br/><br/>基于FPGA实时图像处理的方法，利用FPGA SoC及深度学习等技术手段实时检测视频范围内的入侵情况，并进行标记、上报、预警，可以作为温室大棚的安防检测预警应用。",
        },
        {
          updateTime: "2024-10-30",
          title: "海云捷迅激发新质生产力，点燃智能制造新动能",
          summary: "近日，重庆市科协年会新一代电子信息技术专题学术论坛在重庆仙桃国际大数据谷云湖厅（重庆邮电大学工业互联网学院学术报告厅）隆重举行，海云捷迅作为具有代表性的云计算和人工智能高新技术企业",
        },
        {
          updateTime: "2024-10-28",
          title:
            "AWCloud监控云平台：突破复杂云环境，实现高效资源利用标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长",
          summary: "近日，重庆市科协年会新一代电子信息技术专题学术论坛在重庆仙桃国际大数据谷云湖厅（重庆邮电大学工业互联网学院学术报告厅）隆重举行，海云捷迅作为具有代表性的云计算和人工智能高新技术企业11111111111111111111111111111111111111",
        },
        {
          updateTime: "2024-10-28",
          title:
            "AWCloud监控云平台：突破复杂云环境，实现高效资源利用标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长",
          summary: "近日，重庆市科协年会新一代电子信息技术专题学术论坛在重庆仙桃国际大数据谷云湖厅（重庆邮电大学工业互联网学院学术报告厅）隆重举行，海云捷迅作为具有代表性的云计算和人工智能高新技术企业11111111111111111111111111111111111111",
        },
        {
          updateTime: "2024-10-28",
          title:
            "AWCloud监控云平台：突破复杂云环境，实现高效资源利用标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长",
          summary: "近日，重庆市科协年会新一代电子信息技术专题学术论坛在重庆仙桃国际大数据谷云湖厅（重庆邮电大学工业互联网学院学术报告厅）隆重举行，海云捷迅作为具有代表性的云计算和人工智能高新技术企业11111111111111111111111111111111111111",
        },
        {
          updateTime: "2024-10-28",
          title:
            "AWCloud监控云平台：突破复杂云环境，实现高效资源利用标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长",
          summary: "近日，重庆市科协年会新一代电子信息技术专题学术论坛在重庆仙桃国际大数据谷云湖厅（重庆邮电大学工业互联网学院学术报告厅）隆重举行，海云捷迅作为具有代表性的云计算和人工智能高新技术企业11111111111111111111111111111111111111",
        },
        {
          updateTime: "2024-10-28",
          title:
            "AWCloud监控云平台：突破复杂云环境，实现高效资源利用标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长",
          summary: "近日，重庆市科协年会新一代电子信息技术专题学术论坛在重庆仙桃国际大数据谷云湖厅（重庆邮电大学工业互联网学院学术报告厅）隆重举行，海云捷迅作为具有代表性的云计算和人工智能高新技术企业11111111111111111111111111111111111111",
        },
        {
          updateTime: "2024-10-28",
          title:
            "AWCloud监控云平台：突破复杂云环境，实现高效资源利用标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长",
          summary: "近日，重庆市科协年会新一代电子信息技术专题学术论坛在重庆仙桃国际大数据谷云湖厅（重庆邮电大学工业互联网学院学术报告厅）隆重举行，海云捷迅作为具有代表性的云计算和人工智能高新技术企业11111111111111111111111111111111111111",
        },
        {
          updateTime: "2024-10-28",
          title:
            "AWCloud监控云平台：突破复杂云环境，实现高效资源利用标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长",
          summary: "近日，重庆市科协年会新一代电子信息技术专题学术论坛在重庆仙桃国际大数据谷云湖厅（重庆邮电大学工业互联网学院学术报告厅）隆重举行，海云捷迅作为具有代表性的云计算和人工智能高新技术企业11111111111111111111111111111111111111",
        },
      ],
      currentPage: 1,
      total: 10,
      actives: [
        // { name: "海云捷迅与鼎甲DBackup完成互认证，加强技术协同" },
        // { name: "海云捷迅添彩陶都 中国机器人及人工智能大赛宜兴圆满落幕" },
        // { name: '第八届集创赛全国总决赛"海云捷迅杯"圆满落幕！' },
        // {
        //   name: '海云捷迅亮相2024中国操作系统产业大会 荣获麒麟软件生态共建"突破创新奖"',
        // },
        // { name: "海云捷迅携手清华大学：共筑云边融合检测系统" },
      ],

      currentDetail: "",
    };
  },
  methods: {
    queryNews() {
        queryNewsList({pageSize: 10, pageNum: this.currentPage}).then(res => {
            if(res && res.code == 200) {
                this.total = Number(res.total)
                this.newList = res.rows.map(item => {
                    if(!item.summary) {
                        item.summary = this.removeHtmlTags(item.content, 150)
                    }
                    return item
                })                
            }
        })
    },
    removeHtmlTags(htmlString, maxLength) {
        // 使用正则表达式匹配 HTML 标签并移除
        const plainText = htmlString.replace(/<[^>]+>/g, '').trim();
        return plainText.length > maxLength ? plainText.substring(0, maxLength) + '...' : plainText;
    },
    getActiveList() {
        queryActiveList({limit: 5}).then(res => {
            if(res && res.code == 200) {
                this.actives = res.data
            }
            
        })
    },
    extractYearMonthDay(dateString) {
      const date = new Date(dateString);
      // 注意：月份是从0开始计数的，所以需要加1
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // getMonth()返回0-11，因此需要加1
      const day = date.getDate();

      return {
        year: year,
        month: month < 10 ? "0" + month : month, // 确保月份是两位数
        day: day < 10 ? "0" + day : day, // 确保天数是两位数
      };
    },
    truncateString(input) {
      if(!input) return ''
      if (input.length > 110) {
        // 截取前90个字符并添加"..."
        return input.substring(0, 105) + "...";
      } else {
        // 如果字符串不超过93个字符，则直接返回原字符串
        return input;
      }
    },
    goDetail(item) {
      this.$router.push({ name: 'enterpriseDetail', query: { id: item.id } });
    },
    queryAct(val) {
        this.$router.push({ name: 'enterpriseDetail', query: { id: val.id } });
    },
    choose(val) {
      this.key = val;
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.queryNews()
    }
  },
  mounted() {
    this.queryNews()
    this.getActiveList()
  },
};
</script>